// :cow: Cosmose CONFIDENTIAL :iso:
export const environment = {
  production: true,
  agmKey: 'AIzaSyBYHLNMgJuYZl2y55LNEdiJDkgeH9JfDt4',
  sentryKey: 'https://9073f0f926f64b2f956209b69b8763c4@o176066.ingest.sentry.io/6134006',
  currencies: ['SGD', 'HKD', 'USD'],
};
